var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-framework";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { LotteryMarginCostsModel } from "../../../../../models/modules/lotteryplatofrm.models";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { FormatterHelper } from "../../../../../helpers/numbers-helper";
import * as Enumerable from "linq";
var LotteryMarginCosts = /** @class */ (function (_super) {
    __extends(LotteryMarginCosts, _super);
    function LotteryMarginCosts(notificationService, i18N) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.lotteryMarginCosts = [];
        return _this;
    }
    LotteryMarginCosts.prototype.getLabel = function (range) {
        if (range == null)
            return '';
        return ('Range List: €' + FormatterHelper.getformattedValue(Number(range.rangeFrom), navigator.language, 0)
            + ' - €' + FormatterHelper.getformattedValue(Number(range.rangeTo), navigator.language, 0));
    };
    LotteryMarginCosts.prototype.onActivated = function (item) {
        var _this = this;
        if (!item.lotteryPricingModels)
            item.lotteryPricingModels = [];
        this.lotteryPricingModel = item.lotteryPricingModels[0];
        this.lotteryMarginCosts = Object.create(item.lotteryPricingModels[0].lotteryMarginCosts);
        if (!Enumerable.from(this.lotteryPricingModel.lotteryMarginCosts).any()) {
            var jackpotPriceTier = Enumerable.from(item.lotteryPriceTiers).firstOrDefault(function (x) { return x.isJackpot; });
            Enumerable.from(jackpotPriceTier.lotteryJackpotRanges).where(function (x) { return x.rangeFrom != null; })
                .forEach(function (range) {
                var model = _this.creatingMarginCostModel(range);
                _this.lotteryPricingModel.lotteryMarginCosts.push(model);
                _this.lotteryMarginCosts.push(model);
            });
        }
    };
    LotteryMarginCosts.prototype.creatingMarginCostModel = function (lotteryJackpotRangeModel) {
        var model = new LotteryMarginCostsModel();
        model.lotteryJackpotRangeId = lotteryJackpotRangeModel.lotteryJackpotRangeId;
        model.lotteryJackpotRange = lotteryJackpotRangeModel;
        model.lotteryPricingModelId = this.lotteryPricingModel.lotteryPricingModelId;
        return model;
    };
    LotteryMarginCosts = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N])
    ], LotteryMarginCosts);
    return LotteryMarginCosts;
}(ChildComponent));
export { LotteryMarginCosts };
